<div class="container-fluid h-100 p-0">
  <div *ngIf="accessDenied">
    <app-no-permission></app-no-permission>
  </div>
  <router-outlet *ngIf="!accessDenied"></router-outlet>
</div>
<div *ngIf="isPortrait" class="orientation-message">
  <div class="row info-box justify-content-between align-items-center">
    <div class="col-6 info-box__message">
      <h4>{{ 'annual.orientation.title' | mTranslate }}</h4>
      <hr />
      <p>{{ 'annual.orientation.subtitle' | mTranslate }}</p>
    </div>
    <div class="col-6 info-box__animation">
      <ng-lottie [options]="options" (animationCreated)="animationCreated($event)" />
    </div>
  </div>
</div>
